export default {
  requestCode: {
    jzz: '載入中',
    qzsb: '請求失敗，請稍後重試。如有疑問，請聯繫客服',
    dlsxqcxdl: '登錄失效，請重新登錄',
    dlsxqcxjr: '登錄失效，請重新進入',
    fwqzwxyqshzs: '服務器暫無響應，請稍後再試',
  },
  backStep: '上一步',
  nextStep: '下一步',
  submit: '提交',
  noAllowEmpty: '不能為空',
  bxxbnwk: '必選項不能為空',
  confirm: '確認',
  cancel: '取消',
  reset: '重置',
  success: '完成',
  Understood: '已瞭解',
  已了解: '已瞭解',
  close: '關閉',
  service: '聯繫客服',
  backOpen: '返回開通',
  Step: {
    xxyz: '信息驗證',
    fxpl: '風險披露',
    rlyz: '人臉驗證',
    rjrz: '入金認證',
    vytzzrz: '專業人士認證',
  },
  AudioPlayer: {
    cpdb: '持牌代表：',
    pzh: '牌照號',
    bs: '倍速',
    yue: '約',
    fen: '分',
    miao: '秒',
  },
  CheckBoxList: {
    wyjydjmb: '我已經閱讀及明白',
    khxys: '客戶協議書',
    khsqqrs: '客戶授權確認書',
    nr: '內容；',
  },
  CountryPopup: {
    qsrdqgjzss: '請輸入地區關鍵字搜索',
    cydq: '常用地區',
  },
  // 开户-投资经验
  Investment: {
    ynyx: '1年以下',
    yzhiwunian: '1-5年',
    liuzhishinian: '6-10年',
    shinianyishang: '10年以上',
    baoben: '保本',
    zczz: '資產增值',
    gxhb: '股息回報',
    duichong: '對沖',
    tl: '套利',
    touji: '投機',
    wyyjxyspmm: '我有意進行衍生品買賣',
    simple: {
      wyyjxyspmm: '我有意進行衍生品買賣，並了解衍生品交易中所涉及的風險',
    },
    wwyjxyspmm: '我無意進行衍生品買賣',
    jrjgjbdyspjz: '金融機構舉辦的衍生品講座。',
    jyjgjbyspwskc: '教育機構舉辦衍生品網上課程或教室課程。',
    yhxtgs: '銀行/信託公司',
    zqqhqq: '證券/期貨/期權',
    jjzgjz: '基金/資管公司/家族辦公室',
    jysjrhyxh: '交易所/金融行業協會',
    bxgs: '保險公司',
    ysqz: '衍生權證',
    nxz: '牛熊證',
    qhhqq: '期貨和期權',
    gpggpj: '股票掛鉤票據',
    yq: '遠期',
    dqhh: '掉期（互換）',
    tzjy: '投資經驗',
    gptzjy: '香港上市股票投資經驗',
    jytzjy: '金銀投資經驗',
    whjsptzjy: '外匯及商品投資經驗',
    agtzjy: 'A股投資經驗',
    jjtzjy: '基金投資經驗',
    tzmddx: '投資目的',
    khxys: '客戶協議書',
  },
  DerivativeModel: {
    yspmm: '衍生品買賣',
    nsfljyscpdzytcjfx: '您是否瞭解衍生產品的主要特徵及風險',
    wmbybyscpdzytzqlj:
      '我明白一般衍生產品的主要特徵。且瞭解衍生產品的主要特徵以及衍生交易中所涉及的風險。',
    nxyzsyyyxyscpxgjy: '您需要至少擁有一項衍生產品相關經驗 (多選)',
    wcjsygjsyscpzxzjfxdpxhkc: '我曾接受有關介紹衍生產品之性質及風險的培訓或課程。',
    wxshgwdgzjyywyyscpyg: '我現時或過往的工作經驗/業務與衍生產品有關。',
    wxshgwdgzjyywyyscpygyqxgzy: '我現時或過往的工作經驗/業務與衍生產品有關。與其相關職業和性質為：',
    wxshgwdyyscpygdgzjyywdfwnqw: '我現時或過往的與衍生產品有關的工作經驗/業務的服務年期為：',
    wymmyscpdjymmgdyscps: '我有買賣衍生產品的經驗。買賣過的衍生產品是：',
    yscpbkdbxyysqcnxzgpzsqh:
      '衍生產品包括但不限於衍生權證、牛熊證、股票/指數期貨及期權、商品結構性產品及交易所基金等，無論是否於交易所進行交易。',
    nyqrwytzyscpbckh: '您已確認無意投資衍生產品，本次開戶將不會開通衍生品交易權限。',
  },
  SimpleDerivative: {
    title: '您是否有意進行衍生品買賣？',
    yspmm: '衍生品買賣',
    nsfljyscpdzytcjfx: '您是否瞭解衍生產品的主要特徵及風險',
    wmbybyscpdzytzqlj:
      '我明白一般衍生產品的主要特徵。且瞭解衍生產品的主要特徵以及衍生交易中所涉及的風險。',
    nxyzsyyyxyscpxgjy: '請選擇您的衍生品相關經驗',
    wcjsygjsyscpzxzjfxdpxhkc: '我曾接受有關介紹衍生產品之性質及風險的培訓或課程。',
    wxshgwdgzjyywyyscpyg: '我現時或過往的工作經驗/業務與衍生產品有關。',
    wxshgwdgzjyywyyscpygyqxgzy: '我現時或過往的工作經驗/業務與衍生產品有關。與其相關職業和性質為：',
    wxshgwdyyscpygdgzjyywdfwnqw: '我現時或過往的與衍生產品有關的工作經驗/業務的服務年期為：',
    wymmyscpdjymmgdyscps: '我有買賣衍生產品的經驗。',
    yscpbkdbxyysqcnxzgpzsqh:
      '衍生產品包括但不限於衍生權證、牛熊證、股票/指數期貨及期權、商品結構性產品及交易所基金等，無論是否於交易所進行交易。',
    nyqrwytzyscpbckh: '您已確認無意投資衍生產品，本次開戶將不會開通衍生品交易權限。',
    errorInfo: '開通衍生品權限至少需要勾選一項衍生品相關經驗',
    openText: '開通衍生品權限',
  },
  UploadFile: {
    scz: '上傳中...',
    jzz: '載入中...',
    scsbqcs: '上傳失敗, 請重試',
    xztp: '選擇圖片',
    wjcgzdxz: '文件超過最大限制',
    zctpyupdf: '支持上傳文件(PDF)、圖片',
  },
  fxhlkh: '復星國際證券開戶',
  idCardTip: {
    photoTips: {
      title: '拍照提示',
      des: '拍攝時請確保身份證邊框完整、文字清晰可見、亮度均勻不反光',
    },
    photoError: {
      standard: '標準',
      missing: '邊框缺失',
      vague: '資訊模糊',
      reflex: '圖片反光',
    },
  },
  passwordError: '密碼錯誤',
  tradeDialog: {
    title: '輸入交易密碼',
    sure: '確定',
    tip: '8-20位數字、字母組合',
    passwordVerification: '交易密碼驗證',
    forgotPassword: '忘記密碼',
    noticeText: '當前賬戶類型暫不支持此功能，如有疑問，请联系復星財富客服。',
    freezeText: '當前帳戶已凍結，請聯繫客服',
    toastFreezeText: '提交失敗！賬戶已凍結，請聯系客服。',
  },
  complianceTips: '證券相關服務由復星國際證券提供',
  firstLoginTips: '手機號首次登錄將自動註冊帳號',
  loading: '加載中...',
  djsc: '點擊上傳',
  nyjxzgdqtp: '您已經選擇過當前圖片',
  scz: '上傳中',
  yhmc: '銀行名稱',
  zceddakjrj: '支持eDDA快捷入金',
  zcqtrjfs: '支持其他入金方式',
  复星国际证券: '復星國際證券',
  noticeBarTip: '為保障正常使用交易功能，請閱讀相關協議並授權',
  toAuth: '去授權',
  identifyTitle: '重要提醒',
  identifyText2:
    '尊敬的客戶，您已完成「香港投資者識別碼制度」相關授權，您的賬戶預計將於下一個工作日解除鎖定，請您耐心等待。',
  questText: '如有疑問，請',
  toSign: '立即簽署',
  lookDetail: '查看詳情',
  submitError: '提交失敗',
  openBtn: '立即開戶',
  openTip: '您尚未完成開戶，暫不可申購新股',
  setPasswordBtn: '設置交易密碼',
  setPasswordTip: '您尚未設置交易密碼，暫不可申購新股',
  repeatSendCodeTips: '60s內無須重複獲取驗證碼',
  千: '千',
  万: '萬',
  十万: '十萬',
  百万: '百萬',
  千万: '千萬',
  亿: '億',
  十亿: '十億',
  signAuthTip: '請確認授權後重試',

  伴您财富乘长: '伴您財富乘長',
  音频加载中: '音頻加載中',
  下载: '下載',
  downloadNow: '立即下載',
  mainlandService: '内地客服',
  hkService: '香港客服',

  LivingWitness: {
    rlyz: '人臉驗證',
    qasldzpsydsmbrmbsp: '請按示例動作拍攝一段3秒的本人面部視頻',
    shili: '示例',
    banshenzhengmian: '半身正面照片',
    paishetishi: '拍攝提示',
    qbzmbwz: '請確保臉部完整，保持光線充足;',
    spschrbmykcxps: '視頻上傳後，若不滿意可點擊重新拍攝。',
    dqllqbbbzcsxtqqhllq: '當前瀏覽器版本不支持攝像頭，請切換瀏覽器',
    yzsbqcxyz: '驗證失敗，請重新驗證',
    lzspsbqcxlz: '錄製視頻失敗，請重新錄製',
    qzydddkym: '請在移動端打開頁面',
    rlyztg: '人臉驗證通過',
    spwjgdqcxsc: '視頻文件過大，請重新上傳',
    htsbtp: '活體識別圖片',
    videoShortMsg: '視頻過短，請重新上傳',
    videoLongMsg: '視頻過長, 請重新上傳',
    uploadSuccessMsg: '上傳成功',
    yuji: '預計',
    status_calculating: '正在計算文件校驗碼...',
    status_init: '初始化',
    status_uploading: '正在上傳...',
    status_completing: '正在處理文件...',
    status_done: '上傳完成',
    status_verifying: '認證中',
  },

  tishi: '提示',
  提示: '提示',
  submitSuccess: '提交成功',
  我已确认自愿签署: '我已確認自願簽署',
  '《复星国际证券有限公司客户说明文件》': '《復星國際證劵有限公司客戶說明文件》',
  复星国际证券有限公司客户说明文件: '復星國際證劵有限公司客戶說明文件',
  美股期权交易风险披露声明: '《美股期權交易-風險披露聲明》',
  enterpriseWechatCustomerService: '企業微信客服',
  generatingQrCode: '二維碼生成中...',
  qeCodeGenerationFailed: '二維碼生成失敗',
  longPressQRCode: '長按二維碼保存',
  longPressNotRecognized: '長按無法識別？',
  longPressTip:
    '請長按保存二維碼到您的手機相冊， 打開微信使用掃一掃功能，從相冊中選擇剛纔保存的二維碼圖片識別，即可成功加入羣聊。',
  hkCustomerServiceHotline: '香港客服電話',
  mainlandCustomerServiceHotline: '大陸客服電話',
  weChatBusiness: '企業微信',
  relatedInquiriesPleaseContactCustomerService: '相關諮詢可聯繫客服',
  ContactCustomerService: '聯繫客服',
  customerService: '客服電話',
  riskDisclosureAllow: '本人同意',
  yzmfssb: '驗證碼發送失敗',
  ucAuthLogout: '登出',
  ucAuthLoginExtra: '當前帳號需完成額外驗證，請在 App 中登入',
  riskDisclosureElectronAllowFileName: '《電子簽名的同意書》',
  riskDisclosureElectronDesc:
    '，通過輸入交易密碼及一次性短信驗證碼等電子方式，以進行{name}確認及簽署文件。本人明白此電子簽署方式符合香港《電子交易條例》（第553章）規定，並與本親筆簽名具有同等法律效力。',
  bzcxskf: '抱歉，當前所選國家/地區暫不支持線上開戶，如需辦理請',
  xxcl: '進行線下處理。',
  bzcxskfxg: '抱歉，當前所選國家/地區暫不支持線上修改賬戶資料，如需辦理請',
  sendPage: {
    srdxyzm: '輸入短信驗證碼',
    yfsdxyzmz: '已發送短訊驗證碼至：',
    cxfs: '重新發送',
    sbdyzm: '收不到驗證碼',
    nkylxkfjxyzmcx: '您可以聯繫客服進行驗證碼查詢。',
    dlkf: '内地客服：',
    xgkf: '香港客服：',
    qsrzqdyzmzsyc: '驗證碼錯誤或失效，請重新輸入',
    zdl: '知道了',
    获取语音验证码: '獲取語音驗證碼',
    '我们将通过电话语音告知您验证码，请留意接听。': '我們將通過電話語音告知您驗證碼，請留意接聽。',
    '如仍无法收到，可': '如仍無法收到，可',
    联系客服: '聯繫客服',
    '语音验证码已发送，请留意接听电话': '語音驗證碼已發送，請留意接聽電話',
    重新获取: '重新獲取',
    输入语音验证码: '輸入語音驗證碼',
    我们正在打电话至: '我們正在打電話至：',
    电话将提供验证码: '，電話將提供驗證碼',
    '语音验证码获取频率过高，请稍后再试': '語音驗證碼獲取頻率過高，請稍後再試',
    联系我们: '聯繫我們',
  },
}
